import { appBaseUrl } from "utils/config";
import { getService } from "../../../commonServices";

export class ParticipationTypeService {
  getMailMessageParticipantTypeListing() {
    let url = `${appBaseUrl}/mailMessageCenter/mailMessageParticipantTypeListing`;
    let data = getService(url);
    return data;
  }
}